import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import Loading from "~/components/Loading";
import { useEvalsDashboardFeature } from "~/hooks/useEvalsDashboardFeature";
import { ROUTE_404 } from "~/router/constants";

/**
 * Flag gate for the Evals routes, composed outside the permission gate so a
 * caller who holds `admin:agents` but is not in the rollout gets the same 404 as
 * anyone else. Waits for Flipt rather than redirecting on its initial `false`.
 */
export const EvalsFeatureRoute = ({ children }: { children: ReactNode }) => {
  const { enabled, isLoading } = useEvalsDashboardFeature();

  if (isLoading) {
    return <Loading />;
  }
  if (!enabled) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <>{children}</>;
};
